import { render, staticRenderFns } from "./tiscTabs.vue?vue&type=template&id=5b81fd84&scoped=true&"
import script from "./tiscTabs.vue?vue&type=script&lang=js&"
export * from "./tiscTabs.vue?vue&type=script&lang=js&"
import style0 from "./tiscTabs.vue?vue&type=style&index=0&id=5b81fd84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81fd84",
  null
  
)

export default component.exports